module.exports = __webpack_public_path__ + "img/2.f6f1252e.png";